// Oops Claus store script: gallery, bundle tiers, per-Santa style picker, add-ons, Christmas countdown,
// one-click add to cart -> checkout, sticky bar, order tracking.
(function () {
  var $ = function (id) { return document.getElementById(id); };
  var all = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  // Gallery: swipe, arrows, thumbnails
  var track = $("ocTrack0"), thumbs = $("thumbs") ? $("thumbs").children : [];
  var slideIndex = function () { return track ? Math.round(track.scrollLeft / track.clientWidth) : 0; };
  var goSlide = function (i) {
    if (!track) return;
    var n = track.children.length;
    track.scrollTo({ left: ((i + n) % n) * track.clientWidth, behavior: "smooth" });
  };
  if (track) {
    track.addEventListener("scroll", function () {
      var i = slideIndex();
      for (var t = 0; t < thumbs.length; t++) thumbs[t].classList.toggle("is-on", t === i);
    }, { passive: true });
    if ($("gPrev")) $("gPrev").onclick = function () { goSlide(slideIndex() - 1); };
    if ($("gNext")) $("gNext").onclick = function () { goSlide(slideIndex() + 1); };
    Array.prototype.forEach.call(thumbs, function (b, t) { b.onclick = function () { goSlide(t); }; });
  }
  // Gallery video: tap the sound button to unmute; pause when scrolled away
  all(".gallery__vid").forEach(function (box) {
    var v = box.querySelector("video"), b = box.querySelector(".gallery__sound");
    if (b) b.onclick = function () {
      v.muted = !v.muted;
      if (!v.muted) v.play();
      b.textContent = v.muted ? "🔇 Tap for sound" : "🔊 Sound on";
    };
    if ("IntersectionObserver" in window) new IntersectionObserver(function (en) {
      if (en[0].isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else v.pause();
    }, { threshold: 0.4 }).observe(box);
  });
  var showMedia = function (mediaId) {
    if (!track || !mediaId) return;
    var imgs = track.children;
    for (var i = 0; i < imgs.length; i++) if (+imgs[i].getAttribute("data-media") === mediaId) { goSlide(i); return; }
  };

  // Buy box
  var dataEl = $("ocData"), d = null;
  try { d = dataEl ? JSON.parse(dataEl.textContent) : null; } catch (e) { d = null; }
  if (!d) return trackPage();

  var money = function (cents) {
    var v = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    var f = d.money || "${{amount}}";
    return f.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, v);
  };
  var findVariant = function (c, s) {
    for (var i = 0; i < d.variants.length; i++) {
      var v = d.variants[i];
      if (d.hasChar ? (v.o1 === c && v.o2 === s) : v.o1 === s) return v;
    }
    return null;
  };

  var q = d.tier || 1;
  var slots = all(".slot").map(function (el) { return { el: el, c: d.char, s: d.style }; });

  var paintSlot = function (slot) {
    all(".chars button", slot.el).forEach(function (b) { b.classList.toggle("is-on", b.getAttribute("data-char") === slot.c); });
    all(".style", slot.el).forEach(function (b) {
      var s = b.getAttribute("data-style"), v = findVariant(slot.c, s), img = b.querySelector("img");
      b.classList.toggle("is-on", s === slot.s);
      b.disabled = !v || !v.ok;
      if (v && v.img && img) img.src = v.img;
    });
  };

  var addonsTotal = function () {
    return all(".addon.is-on").reduce(function (t, a) { return t + (+a.getAttribute("data-price") || 0); }, 0);
  };
  var paintTotal = function () {
    var off = d.off[q - 1] || 0, adds = addonsTotal();
    var santas = d.unit * q - off, t = santas + adds;
    var was = Math.round(santas * (d.cmp || d.unit) / d.unit), save = was - santas;
    if ($("ocTotal")) $("ocTotal").textContent = money(t);
    if ($("ocWas")) $("ocWas").textContent = save > 0 ? money(was + adds) : "";
    if ($("ocSave")) {
      $("ocSave").hidden = !(save > 0);
      $("ocSave").textContent = "🎉 You're saving " + money(save) + " (" + Math.round(save * 100 / was) + "% off)";
    }
    if ($("ocStickyTotal")) $("ocStickyTotal").textContent = money(t);
    if ($("ocStickySave")) $("ocStickySave").textContent = save > 0 ? "Save " + money(save) : "";
  };

  all(".tier").forEach(function (b) {
    b.addEventListener("click", function () {
      q = +b.getAttribute("data-q") || 1;
      all(".tier").forEach(function (x) { x.classList.toggle("is-on", x === b); x.setAttribute("aria-checked", x === b ? "true" : "false"); });
      slots.forEach(function (s, i) { s.el.hidden = i >= q; });
      paintTotal();
    });
  });

  slots.forEach(function (slot) {
    all(".chars button", slot.el).forEach(function (b) {
      b.addEventListener("click", function () {
        slot.c = b.getAttribute("data-char");
        paintSlot(slot);
        var v = findVariant(slot.c, slot.s); if (v) showMedia(v.media);
      });
    });
    all(".style", slot.el).forEach(function (b) {
      b.addEventListener("click", function () {
        slot.s = b.getAttribute("data-style");
        paintSlot(slot);
        var v = findVariant(slot.c, slot.s); if (v) showMedia(v.media);
      });
    });
    paintSlot(slot);
  });

  all(".addon").forEach(function (a) {
    a.addEventListener("click", function () {
      var on = !a.classList.contains("is-on");
      a.classList.toggle("is-on", on);
      a.setAttribute("aria-pressed", on ? "true" : "false");
      paintTotal();
    });
  });
  paintTotal();

  // Add every picked Santa + ticked add-ons in one request, then go straight to checkout.
  var buying = false;
  var buy = function (e) {
    if (e) e.preventDefault();
    if (buying) return;
    var counts = {}, items = [];
    for (var i = 0; i < q; i++) {
      var s = slots[i] || slots[0], v = findVariant(s.c, s.s);
      if (v) counts[v.id] = (counts[v.id] || 0) + 1;
    }
    Object.keys(counts).forEach(function (id) { items.push({ id: +id, quantity: counts[id] }); });
    all(".addon.is-on").forEach(function (a) { items.push({ id: +a.getAttribute("data-vid"), quantity: 1 }); });
    if (!items.length) return;
    buying = true;
    var btns = [$("ocBuy"), $("ocStickyBuy")];
    btns.forEach(function (b) { if (b) b.setAttribute("aria-busy", "true"); });
    fetch("/cart/clear.js", { method: "POST", headers: { Accept: "application/json" } })
      .then(function () {
        return fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ items: items }) });
      })
      .then(function (r) { if (!r.ok) throw new Error("add failed"); location.href = "/checkout"; })
      .catch(function () {
        buying = false;
        btns.forEach(function (b) { if (b) b.removeAttribute("aria-busy"); });
        location.href = "/cart";
      });
  };
  if ($("ocForm")) $("ocForm").addEventListener("submit", buy);
  if ($("ocStickyBuy")) $("ocStickyBuy").addEventListener("click", buy);

  // Sticky bar shows once the main button scrolls away
  var bar = $("ocSticky"), main = $("ocBuy");
  if (bar && main && "IntersectionObserver" in window) {
    new IntersectionObserver(function (en) {
      bar.classList.toggle("is-on", !en[0].isIntersecting && en[0].boundingClientRect.top < 0);
    }).observe(main);
  }

  // Countdown to the real Christmas cutoff date (hidden once it has passed)
  var cd = $("ocCountdown");
  if (cd) {
    var parts = (cd.getAttribute("data-cutoff") || "").split("-");
    var end = new Date(+parts[0], (+parts[1] || 1) - 1, +parts[2] || 1, 23, 59, 59);
    var pad = function (n) { return (n < 10 ? "0" : "") + n; };
    var shows = [cd].concat(all(".oc-urgent"));
    var tick = function () {
      var ms = end - new Date();
      if (!(ms > 0)) { shows.forEach(function (e) { e.hidden = true; }); return false; }
      var s = Math.floor(ms / 1000), dd = Math.floor(s / 86400), h = Math.floor(s % 86400 / 3600), m = Math.floor(s % 3600 / 60);
      var box = function (v) { return "<i>" + v + "</i>"; };
      var html = (dd ? box(dd + "d") + " " : "") + box(pad(h)) + ":" + box(pad(m)) + ":" + box(pad(s % 60));
      all(".oc-clock").forEach(function (e) { e.innerHTML = html; });
      shows.forEach(function (e) { e.hidden = false; });
      return true;
    };
    if (tick()) setInterval(tick, 1000);
  }

  trackPage();

  // Track order page (17TRACK widget, falls back to the 17TRACK site)
  function trackPage() {
    var tf = $("ocTrack");
    if (!tf) return;
    tf.addEventListener("submit", function () {
      var num = $("YQNum").value.trim();
      if (!num) return;
      if (!window.YQV5) { location.href = "https://t.17track.net/en#nums=" + encodeURIComponent(num); return; }
      window.YQV5.trackSingle({ YQ_ContainerId: "YQContainer", YQ_Height: 560, YQ_Fc: "0", YQ_Lang: "en", YQ_Num: num });
    });
  }
})();
